import { ListViewChildProps } from '@app/core/list-view/ListView';
import { SavedReportsTable } from '../components/SavedReportsTable';
import { SavedReportListItem } from '../types';

/**
 * GIP / GIP alt table: includes creator and export status columns.
 */
export function SavedReportsGipTable(props: ListViewChildProps<SavedReportListItem>) {
  return <SavedReportsTable {...props} showCreatedBy showExportStatus />;
}
